import styled, { css } from 'styled-components';
import { colors, media } from '@bitcoin-portal/bitcoincom-pkg-theme';
export const Wrapper = styled.div `
  ${({ sticky }) => css `
    width: 100%;
    box-sizing: border-box;
    padding: 20px 32px;
    background: ${colors.solid.bgGrey};

    ${media.md `
      padding: 20px 70px;
    `}

    ${media.lg `
      padding: 20px 100px;
    `}
    ${sticky &&
    css `
      background: ${colors.solid.bgGrey};
      box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.05), 0 3px 6px 0 rgba(0, 0, 0, 0.06);
    `}
  `}
`;
export const Content = styled.div `
  display: flex;
  box-sizing: border-box;
  margin: auto;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1440px;
  background: ${colors.solid.bgGrey};
`;
export const Logo = styled.img `
  width: 108px;
  height: 16px;

  ${media.md `
    width: 170px;
    height: 24px;
  `}
`;
//# sourceMappingURL=styled.js.map